import { createApp } from "vue";
import App from "./App.vue";
import { resolveSection } from "./routes.js";
import { CORE, preload } from "./lib/preload.js";

// Some generated data is read synchronously all over the site (the unit grade on
// every card needs rosterStats), so it has to be loaded before anything renders.
// Load what this page needs from S3 first (lib/preload.js), and start fetching the
// page's own code at the same moment so the two downloads overlap.
const section = resolveSection();
if (section.loader) section.loader().catch(() => {});   // App's async component reports its own errors

preload([...CORE, ...(section.data || [])])
  .then(() => createApp(App).mount("#app"))
  .catch((e) => {
    console.error("Couldn't load the site's data", e);
    const el = document.getElementById("app");
    el.innerHTML =
      '<div style="max-width:28rem;margin:18vh auto;padding:1.4rem 1.6rem;background:#0a1c2e;color:#e8eef5;' +
      'border:1px solid #2c4a66;border-radius:8px;font:15px/1.5 system-ui,sans-serif;text-align:center">' +
      "<b>Couldn't load the site's data.</b><br>Usually a flaky connection. Try again in a moment." +
      '<br><button style="margin-top:.9rem;padding:.45rem 1.2rem;font:inherit;cursor:pointer">Retry</button></div>';
    el.querySelector("button").onclick = () => location.reload();
  });
